$(document).ready(function() {
	if ($('.jq_toggle').length) {
		$('.jq_toggle_control:checked').each(function() {
			var $toggle = $(this).parent('.jq_toggle');

			$('.jq_toggle_panel', $toggle).show();
		});

		$(document).on('change', '.jq_toggle_control', function() {
			var $toggle = $(this).parent('.jq_toggle');

			if ($(this).hasClass('jq_toggle_one')) {
				var $toggles = $('[name="' + $(this).attr('name') + '"]');

				$toggles.not(this).prop('checked', false);

				$toggles.nextAll('.jq_toggle_panel').slideUp();

				if ($(this).is(':checked')) {
					$('.jq_toggle_panel', $toggle).slideDown();
				}
			} else {
				$('.jq_toggle_panel', $toggle).slideToggle();
			}
		});
	}
});
